var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tasks.length)?_c('b-tabs',_vm._l((_vm.tasks),function(task){return _c('b-tab',{key:task.id,attrs:{"title":task.task.name}},[_c('schedule-task-results',{attrs:{"instances":task.instances,"task":task.task,"samples":task.samples,"analyses":task.analyses}})],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }